/** @jsx jsx */
import React from 'react';

import { Interpolation, jsx, Theme } from '@emotion/react';
import { Button } from '../../components/Button';

type ButtonVariant = 'greenGradient';

interface ContainerProps {
    css?: Interpolation<Theme>;
    variant: ButtonVariant;
    label: string;
    clickEvent: `internal` | `external` | 'submit';
    clickEventTarget: string;
    renderAsButton: boolean;
}

export const ModuleButton: React.FC<ContainerProps> = ({
    clickEvent,
    clickEventTarget,
    label,
    variant,
    renderAsButton,
    ...props
}) => {
    return (
        <Button
            variant={variant}
            {...(clickEvent === 'internal' && { to: clickEventTarget })}
            {...(clickEvent === 'external' && {
                external: true,
                to: clickEventTarget,
            })}
            {...(clickEvent === 'submit' && {
                type: 'submit',
                formSubmit: true,
            })}
            {...props}
        >
            {label && label}
        </Button>
    );
};
